import { nameByPlatform } from "~/constants/platfroms";
import type { IMarket } from "~/types/event";
import type { PlatformEnum } from "~/types/platform";

// One outcome: the rows differ by platform, so they are named by platform, as
// the mockup has it. Several outcomes: the platform is already on the badge and
// two rows could otherwise both read "Predict", so the outcome names them.
export const getEmbedRowLabels = (markets: IMarket[]): string[] => {
  const outcomes = new Set(
    markets.map(({ title }) => (title ?? "").trim().toLowerCase())
  );

  return markets.map(({ title, platform }) =>
    outcomes.size > 1
      ? (title ?? "")
      : nameByPlatform[platform as PlatformEnum]
  );
};
